<template>
  <div class="BaseSetMap">
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>地图风格</span>
      </div>
      <div>
        <ul class="mapList">
          <li v-for="(item,index) in mapList" :key="index">
            <el-image :class="activeIndex === item.layer?'active':''" @click="changeMapLayer(item,index)" :src="item.url" fit="cover"></el-image>
            <div class="name">{{item.name}}</div>
            <div class="check" v-if="activeIndex === item.layer"><img src="~@/assets/images/xuanze.png" alt=""></div>
          </li>
        </ul>
        <div class="form-item">
          <div class="label">显示地点名称</div>
            <el-switch  v-model="isShowLabel" active-color="#00A4F0" inactive-color="#494B4D" @change="onLabelChange">
          </el-switch>
        </div>
        <div class="form-item">
          <div class="label">底图亮度</div>
          <el-input-number v-model="mapLight" controls-position="right" :min="0" :max="20" @change="changeMapLight" :precision="2" :step="1"></el-input-number>
        </div>
      </div>
    </div>
    <div class="styleSetting">
      <div class="title">
        <span class="line"></span>
        <span>模型设置</span>
      </div>
      <div>
        <div class="form-item">
          <div class="label">场景亮度</div>
          <el-input-number v-model="modelLight" controls-position="right" :min="0" :max="20" :precision="2" :step="1" @change="changeModelLight"></el-input-number>
        </div>
        <div class="form-item">
          <div class="label">模型高度</div>
          <el-input-number v-model="modelHeight" controls-position="right" :controls="true" @change="changeModelHight"></el-input-number>
        </div>
        <div class="form-item">
          <div class="label">显示精度</div>
          <!-- <div class="slider">
            <span class="text" style="color: #ffffff;margin-right: 0.18rem">{{maximumScreenSpaceError}}</span>
            <el-slider v-model="maximumScreenSpaceError" :min="0" :max="256" :step="0.1" @change="changeMaximumScreenSpaceError"></el-slider>
          </div> -->
          <el-input-number v-model="maximumScreenSpaceError" controls-position="right" :min="0.1" :max="256"  @change="changeMaximumScreenSpaceError" :precision="1" :step="1"></el-input-number>
        </div>
        <div class="form-item">
          <div class="label">最大内存</div>
          <!-- <div class="slider">
            <span class="text" style="color: #ffffff;margin-right: 0.18rem">{{maximumMemoryUsage}}</span>
            <el-slider v-model="maximumMemoryUsage" :min="512" :max="5120" :step="1" @change="changeMaximumMemoryUsage"></el-slider>
          </div> -->
          <el-input-number v-model="maximumMemoryUsage" controls-position="right" :min="512" :max="5120"  @change="changeMaximumMemoryUsage" :step="1"></el-input-number>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addMapStyle, editMapStyle } from '@/api/mapStyle'
import CesiumPlus from '../../../../libs/cesiumExtents/CesiumPlus'
export default {
  name: 'BaseSetMap',
  props: {},
  components: { },
  data () {
    return {
      activeIndex: 'TianDiMapImgLayer',
      mapList: [
        {
          name: '天地图影像',
          url: require('../../../../assets/images/tianditu.png'),
          layer: 'TianDiMapImgLayer'
        },
        {
          name: '天地图矢量',
          url: require('../../../../assets/images/tianditu2.png'),
          layer: 'TianDiMapVecLayer'
        },
        {
          name: '高德影像',
          url: require('../../../../assets/images/gaode.png'),
          layer: 'AmapImgLayer'
        },
        {
          name: '高德矢量',
          url: require('../../../../assets/images/gaode2.png'),
          layer: 'AmapVecLayer'
        }
        // {
        //   name: 'Bing影像',
        //   url: require('../../../../assets/images/bing.png'),
        //   layer: 'BingMapImgVecLayer'
        // },
        // {
        //   name: 'ArcGis',
        //   url: require('../../../../assets/images/ArcGis.png'),
        //   layer: 'ArcGisMapImgVecLayer'
        // }
      ],
      mapLight: 10,
      modelHeight: 1,
      modelLight: 10,
      maximumScreenSpaceError: 16,
      maximumMemoryUsage: 512,
      isShowLabel: true,
      mapStyle: 'TianDiMapImgLayer',
      cacheData: {}
    }
  },
  computed: {
  },
  watch: {
    mapStyle (newValue, oldValue) {
    }
  },
  methods: {
    changeMapLayer (item, index) {
      this.activeIndex = item.layer
      this.mapStyle = item.layer
      this.$cesiumPlus.imageryManager.switchBaseLayer(CesiumPlus.LayerDefine[item.layer])
      this.isDisabled()
    },
    changeModelHight (v) {
      this.$emit('changeModelHeight', v)
      this.modelHeight = v
      this.isDisabled()
    },
    onLabelChange (v) {
      if (v) {
        this.$cesiumPlus.imageryManager.switchLabelLayer(CesiumPlus.LayerDefine.TianDiMapLabelLayer)
      } else {
        this.$cesiumPlus.imageryManager.switchLabelLayer(undefined)
      }
      this.isDisabled()
    },
    changeMapLight (v) {
      this.$cesiumPlus.imageryManager.getBaseLayer().brightness = v * 0.1
      this.mapLight = v
      this.isDisabled()
    },
    changeModelLight (v) {
      this.modelLight = v
      const brightnessStage = this.$brightnessStage
      brightnessStage.uniforms.brightness = v * 0.1
      // this.$cesiumPlus.viewer.scene.postProcessStages.add(brightnessStage)
      this.isDisabled()
    },
    changeMaximumScreenSpaceError (v) {
      this.maximumScreenSpaceError = v
      this.$cesiumPlus.cesium3DTilesetManager.setAllTilesetOptions({
        maximumScreenSpaceError: this.maximumScreenSpaceError
      })
      this.isDisabled()
    },
    changeMaximumMemoryUsage (v) {
      this.maximumMemoryUsage = v
      this.$cesiumPlus.cesium3DTilesetManager.setAllTilesetOptions({
        maximumMemoryUsage: this.maximumMemoryUsage
      })
      this.isDisabled()
    },
    save () {
      const params = {
        'mapBrightness': this.mapLight,
        'mapId': parseFloat(this.$route.query.mapId),
        'mapStyle': this.mapStyle,
        'modelHeight': this.modelHeight,
        'modelBrightness': this.modelLight,
        'maximumScreenSpaceError': this.maximumScreenSpaceError,
        'maximumMemoryUsage': this.maximumMemoryUsage,
        'labelLayer': this.isShowLabel ? 'TianDiMapLabelLayer' : 'DefaultLocalImager'
      }
      addMapStyle(params).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg)
          this.$store.commit('SELECT_MODELHEIGHT', this.modelHeight)
          this.$cesiumPlus.cesium3DTilesetManager.setAllTilesetOptions({
            maximumScreenSpaceError: this.maximumScreenSpaceError,
            maximumMemoryUsage: this.maximumMemoryUsage
          })
          this.$emit('changeDisabled', true)
        }
      })
    },
    edit () {
      const params = {
        'mapBrightness': this.mapLight,
        'id': this.styleId,
        'mapStyle': this.mapStyle,
        'modelHeight': this.modelHeight,
        'modelBrightness': this.modelLight,
        'maximumScreenSpaceError': this.maximumScreenSpaceError,
        'maximumMemoryUsage': this.maximumMemoryUsage,
        'labelLayer': this.isShowLabel ? 'TianDiMapLabelLayer' : 'DefaultLocalImager'
      }
      editMapStyle(params).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg)
          this.$store.commit('SELECT_MODELHEIGHT', this.modelHeight)
          this.$cesiumPlus.cesium3DTilesetManager.setAllTilesetOptions({
            maximumScreenSpaceError: this.maximumScreenSpaceError,
            maximumMemoryUsage: this.maximumMemoryUsage
          })
          this.$emit('changeDisabled', true)
        }
      })
    },
    restore () {
      if (this.mapLight !== this.cacheData.mapLight) {
        this.mapLight = this.cacheData.mapLight
        this.$cesiumPlus.imageryManager.getBaseLayer().brightness = this.mapLight * 0.1
      }
      if (this.mapStyle !== this.cacheData.mapStyle) {
        this.mapStyle = this.cacheData.mapStyle
        this.$cesiumPlus.imageryManager.switchBaseLayer(CesiumPlus.LayerDefine[this.mapStyle])
      }
      if (this.modelLight !== this.cacheData.modelLight) {
        this.modelLight = this.cacheData.modelLight
        const brightnessStage = this.$brightnessStage
        brightnessStage.uniforms.brightness = this.modelLight * 0.1
        // this.$cesiumPlus.viewer.scene.postProcessStages.add(brightnessStage)
      }
      if (this.modelHeight !== this.cacheData.modelHeight) {
        this.modelHeight = this.cacheData.modelHeight
        this.$emit('changeModelHeight', this.modelHeight)
      }
      if (this.maximumScreenSpaceError !== this.cacheData.maximumScreenSpaceError) {
        this.maximumScreenSpaceError = this.cacheData.maximumScreenSpaceError
      }
      if (this.maximumMemoryUsage !== this.cacheData.maximumMemoryUsage) {
        this.maximumMemoryUsage = this.cacheData.maximumMemoryUsage
      }
      this.$cesiumPlus.cesium3DTilesetManager.setAllTilesetOptions({
        maximumScreenSpaceError: this.maximumScreenSpaceError,
        maximumMemoryUsage: this.maximumMemoryUsage
      })
      const isShowLabel = CesiumPlus.LayerDefine[this.cacheData.labelLayer] >= CesiumPlus.LayerDefine.TianDiMapLabelLayer
      if (isShowLabel !== this.isShowLabel) {
        this.isShowLabel = isShowLabel
        this.$cesiumPlus.imageryManager.switchLabelLayer(isShowLabel ? CesiumPlus.LayerDefine.TianDiMapLabelLayer : undefined)
      }
    },
    // 判断保存按钮是否禁用
    isDisabled () {
      console.log(this.cacheData)
      if (this.cacheData.mapStyle === this.mapStyle &&
      this.cacheData.mapLight === this.mapLight &&
      this.cacheData.modelHeight === this.modelHeight &&
      this.cacheData.labelLayer === this.labelLayer &&
      this.cacheData.maximumScreenSpaceError === this.maximumScreenSpaceError &&
      this.cacheData.maximumMemoryUsage === this.maximumMemoryUsage &&
      this.cacheData.modelLight === this.modelLight) {
        this.$emit('changeDisabled', true)
      } else {
        this.$emit('changeDisabled', false)
      }
    },
    async setStyle (data) {
      // 回显输入框值
      this.mapLight = data.mapBrightness
      this.mapStyle = data.mapStyle
      this.modelLight = data.modelBrightness
      this.modelHeight = data.modelHeight
      this.maximumScreenSpaceError = data.maximumScreenSpaceError || 16
      this.maximumMemoryUsage = data.maximumMemoryUsage || 512
      this.isShowLabel = CesiumPlus.LayerDefine[data.labelLayer] >= CesiumPlus.LayerDefine.TianDiMapLabelLayer
      // 回显设置地图样式
      await this.$cesiumPlus.imageryManager.switchBaseLayer(CesiumPlus.LayerDefine[this.mapStyle])
      if (this.isShowLabel) {
        this.$cesiumPlus.imageryManager.switchLabelLayer(
          CesiumPlus.LayerDefine[data.labelLayer]
        )
      }
      // this.changeMapLight(this.mapLight)
      // 回显设置地图亮度
      this.$cesiumPlus.imageryManager.getBaseLayer().brightness = data.mapBrightness * 0.1
      // this.changeModelLight(this.modelLight)
      // 回显设置模型亮度
      const brightnessStage = this.$brightnessStage
      brightnessStage.uniforms.brightness = data.modelBrightness * 0.1
      // if (this.$cesiumPlus.viewer.scene.postProcessStages.length <= 0) {
      //   this.$cesiumPlus.viewer.scene.postProcessStages.add(brightnessStage)
      // }
      this.activeIndex = this.mapStyle
      this.styleId = data.id
      // 记录第一次进来的样式，用来判断保存按钮是否禁用
      this.cacheData.mapStyle = data.mapStyle || 'TianDiMapImgLayer'
      this.cacheData.modelLight = data.modelBrightness || 10
      this.cacheData.modelHeight = data.modelHeight || 1
      this.cacheData.mapLight = data.mapBrightness || 10
      this.cacheData.maximumScreenSpaceError = data.maximumScreenSpaceError || 16
      this.cacheData.maximumMemoryUsage = data.maximumMemoryUsage || 512
      this.cacheData.labelLayer = data.labelLayer || 'TianDiMapLabelLayer'
      console.log(4, this.cacheData)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .BaseSetMap{
    text-align: left;
    .title{
      color: #FFFFFF;
      font-size: 14px;
      margin-bottom: 15px;
      >.line{
        display: inline-block;
        margin-right: 4px;
        width: 3px;
        height: 10px;
        background: #00A4F0;
        border-radius: 2px;
      }
    }
    .el-input .el-input__inner{
      font-size: 12px !important;
      text-align: left;
    }
    .el-input__prefix{
      display: flex;
      align-items: center;
      padding-left: 10px;
      >img{
        width: 15px;
        height: 15px;
      }
    }
    .el-radio-group{
      width: 155px;
      display: flex;
      .el-radio{
        margin-right: 16px;
        transform: scale(0.9);
      }
    }
    .slider{
      width: 230px;
      height: 32px;
      background: #424243;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      align-items: center;
      padding: 0 12px;
      box-sizing: border-box;
      .el-slider{
        width: 100%;
        .el-slider__runway{
          height: 4px;
        }
        .el-slider__bar{
          height: 4px;
          background-color: $primary-color;
        }
        .el-slider__button{
          width: 8px;
          height: 8px;
          border: solid 0.02rem #ffffff;
          background-color: $primary-color;
          transform: translateY(-1px);
        }
      }
    }
    .baseInfo{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .form-item{
        margin-bottom: 16px;
        >.label{
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          margin-bottom: 8px;
        }
      }
      .type{
        margin-bottom: 5px;
        .label{
          font-size: 13px;
          color: rgba(255, 255, 255, 0.3);
        }
        .value{
          font-size: 13px;
          color: #00A4F0;
        }
      }
    }
    .styleSetting{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      .imgType{
        margin-bottom: 30px;
        >img{
          width: 60px;
          height: 60px;
          background: #373839;
          border-radius: 6px;
          margin-right: 26px;
          margin-bottom: 8px;
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .label{
          width: 120px;
          font-size: 12px;
          color: #999999;
        }
        .slider{
          width: 230px;
          height: 32px;
          background: #424243;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;
          .el-slider{
            width: 100%;
            .el-slider__runway{
              height: 4px;
            }
            .el-slider__bar{
              height: 4px;
              background-color: $primary-color;
            }
            .el-slider__button{
              width: 8px;
              height: 8px;
              border: solid 0.02rem #ffffff;
              background-color: $primary-color;
              transform: translateY(-1px);
            }
          }
        }
      }
    }
    .mapList{
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 10px;
      >li{
        width: 60px;
        height: 100px;
        border-radius: 6px;
        position: relative;
        .el-image{
          width: 60px;
          height: 60px;
          border-radius: 6px;
          cursor: pointer;
          border: 2px solid rgba(0, 164, 240, 0);
          box-sizing: border-box;
          &.active{
            border: 2px solid rgba(0, 164, 240, 0.94);
            box-shadow: 0 0 7px rgba(25, 195, 240, 0.9);
          }
        }
        img{
          width: 100%;
          height: 100%;
        }
        .name{
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
          text-align: center;
          transform: translateY(-2px);
        }
        .check{
          position: absolute;
          right: 0;
          top: 39px;
        }
      }
    }
    .el-input-number{
      .el-input-number__increase, .el-input-number__decrease{
        border: 0 !important;
        height: 16px;
      }
      .is-disabled{
        border: 0 !important;
      }
    }
  }
</style>
